"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntendedState = void 0;
var IntendedState;
(function (IntendedState) {
    IntendedState["Alarm"] = "alarm";
    IntendedState["Disconnected"] = "disconnected";
    IntendedState["FanSpeed"] = "fanSpeed";
    IntendedState["HeaterOn"] = "heaterOn";
    IntendedState["Level"] = "level";
    IntendedState["LidOpen"] = "lidOpen";
    IntendedState["LightOn"] = "lightOn";
    IntendedState["Mode"] = "mode";
    IntendedState["On"] = "on";
    IntendedState["PumpOn"] = "pumpOn";
    IntendedState["SetTemperature"] = "setTemp";
    IntendedState["State"] = "state";
})(IntendedState = exports.IntendedState || (exports.IntendedState = {}));
//# sourceMappingURL=EventMessage.js.map